import client from './client';

export async function getStoreList() {
  const res = await client.get('/admin/store');
  return res.data;
}

export async function getStore(storeId) {
  const res = await client.get(`/admin/store/${storeId}`);
  return res.data;
}

export async function createStore(payload) {
  const res = await client.post('/admin/store', payload);
  return res.data;
}

export async function updateStore(storeId, payload) {
  const res = await client.put(`/admin/store/${storeId}`, payload);
  return res.data;
}

export async function deleteStore(storeId) {
  const res = await client.delete(`/admin/store/${storeId}`);
  return res.data;
}

export async function getStoreTables(storeId) {
  const res = await client.get(`/admin/store/${storeId}/table`);
  return res.data;
}

export async function createStoreTable(storeId, payload) {
  const res = await client.post(`/admin/store/${storeId}/table`, payload);
  return res.data;
}

export async function updateStoreTable(tableId, payload) {
  const res = await client.put(`/admin/store/table/${tableId}`, payload);
  return res.data;
}

export async function deleteStoreTable(tableId) {
  const res = await client.delete(`/admin/store/table/${tableId}`);
  return res.data;
}

// ===================== 매장별 취급 제외 상품 =====================

/** 해당 매장이 취급하지 않는 상품 ID 목록 */
export async function getExcludedProducts(storeId) {
  const res = await client.get(`/admin/store/${storeId}/excluded-products`);
  return res.data;
}

/** 상품을 취급 제외 (이 매장에서 취급 안 함) */
export async function excludeProduct(storeId, productId, createdBy) {
  const res = await client.post(`/admin/store/${storeId}/excluded-products/${productId}`, { createdBy });
  return res.data;
}

/** 취급 제외 해제 (다시 취급) */
export async function includeProduct(storeId, productId) {
  const res = await client.delete(`/admin/store/${storeId}/excluded-products/${productId}`);
  return res.data;
}

// ===================== 매장별 취급 제외 상품옵션 =====================

/** 해당 매장이 취급하지 않는 상품옵션 ID 목록 */
export async function getExcludedOptions(storeId) {
  const res = await client.get(`/admin/store/${storeId}/excluded-options`);
  return res.data;
}

/** 상품옵션을 취급 제외 (이 매장에서 이 옵션만 취급 안 함) */
export async function excludeOption(storeId, optionId, createdBy) {
  const res = await client.post(`/admin/store/${storeId}/excluded-options/${optionId}`, { createdBy });
  return res.data;
}

/** 취급 제외 해제 (다시 취급) */
export async function includeOption(storeId, optionId) {
  const res = await client.delete(`/admin/store/${storeId}/excluded-options/${optionId}`);
  return res.data;
}

// ===================== 매장별 리뷰 유도(보상 안내) 설정 =====================
// 레퍼런스 벤치마킹 - 매장이 리뷰 유도 배너 사용여부/문구를 직접 설정한다.

export async function getStoreReviewIncentive(storeId) {
  const res = await client.get(`/admin/store/${storeId}/review-incentive`);
  return res.data;
}

export async function saveStoreReviewIncentive(storeId, payload, updatedBy) {
  const res = await client.put(`/admin/store/${storeId}/review-incentive`, payload, { params: { updatedBy } });
  return res.data;
}
